var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitediamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 15",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "8u73ane84__v1ommxxlza",
    d: "M0 0H20V20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8u73ane84__3vjxs92r6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8u73ane84__v1ommxxlza"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4545455,2.5 L20,8.33333333 L10,17.5 L0,8.33333333 L4.54545455,2.5 L15.4545455,2.5 Z M13.5818182,5.83333333 L6.41818182,5.83333333 L4.74545455,7.98333333 L10,12.8 L15.2545455,7.98333333 L13.5818182,5.83333333 Z",
    fill: "#FFF",
    mask: "url(#8u73ane84__3vjxs92r6b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitediamond);
export default __webpack_public_path__ + "static/media/invitediamond.503a9e733f30a1b31a96a38e6dfcc189.svg";
export { ForwardRef as ReactComponent };